import qs from 'qs';
import client from './client';

const productUrl = '/api/v1/master/product';

//제품 리스트 가져오기
export const getProducts = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${productUrl}/list?${queryString}`);
};

//가격정보 있는 제품 리스트
export const getProductPriceList = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${productUrl}/price?${queryString}`);
};

//매출처 선택 후 제품 리스트
export const getProductPriceListByVendor = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${productUrl}/priceList?${queryString}`);
};

//제품명 중복체크
export const checkPrdNameDuplicate = (data) => {
  const queryString = qs.stringify(data);
  return client.get(`${productUrl}/info/validation?${queryString}`);
};

export const getCategoryByTyp = (prdTyp) => {
  return client.get(`${productUrl}/category/${prdTyp}`);
};

//제품 추가
export const addProduct = (dataToSubmit) => {
  return client.post(`${productUrl}/info`, dataToSubmit);
};

//제품+매입처정보
export const addProductBase = (dataToSubmit) => {
  return client.post(`${productUrl}/info/base`, dataToSubmit);
};

//제품 정보
export const getProduct = (id) => client.get(`${productUrl}/info/${id}`);
export const getProductBase = (id) =>
  client.get(`${productUrl}/info/base/${id}`);

export const editProduct = (id, dataToSubmit) => {
  return client.put(`${productUrl}/info/${id}`, dataToSubmit);
};

export const editProductBase = (id, dataToSubmit) => {
  return client.put(`${productUrl}/info/base/${id}`, dataToSubmit);
};

//제품 삭제
export const removeProduct = (id) => client.delete(`${productUrl}/info/${id}`);

//제품가격정보
export const getProductPrices = (id) =>
  client.get(`${productUrl}/info/${id}/price`);

//제품가격정보 등록
export const addProductPrices = (dataToSubmit) => {
  return client.post(
    `${productUrl}/info/${dataToSubmit.productUuid}/price`,
    dataToSubmit,
  );
};

//제품가격수정
export const editProductPrices = (id, dataToSubmit) => {
  return client.put(
    `${productUrl}/info/${id}/price/${dataToSubmit.priceUuid}`,
    dataToSubmit,
  );
};

//제품 가격 삭제
export const removeProductPrice = (prodcutId, priceId) => {
  return client.delete(`${productUrl}/info/${prodcutId}/price/${priceId}`);
};

export const uploadExl = (formData) => {
  return client.post(`${productUrl}/uploadExl`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

export const downloadExcel = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${productUrl}/downloadExl?${queryString}`, {
    responseType: 'arraybuffer',
  });
};

//
